import React from 'react';

const AdminWrapper = ({ children }) => {
  const isAdmin = localStorage.getItem('admin') === 'true';

  return isAdmin ? <>{children}</> : null;
};

export default AdminWrapper;
